function getUserAgent() {
    return navigator.userAgent || navigator.vendor || window.opera
}

export function isInAppBrowser() {
    const inAppPatterns = [
        /FBAN|FBAV/,           // Facebook
        /Instagram/,           // Instagram
        /Twitter/,             // Twitter
        /TikTok/,              // TikTok
        /LinkedInApp/,         // LinkedIn
        /Snapchat/,            // Snapchat
        /WhatsApp/,            // WhatsApp
        /MicroMessenger/       // WeChat
    ]

    return inAppPatterns.some(pattern => pattern.test(getUserAgent()))
}

export function isIos() {
    return /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream
}

export function isIosBrowser() {
    return isIos() && !window.navigator.standalone
}

export function isMac() {
    return /Mac|iPhone|iPad|iPod/.test(navigator.platform)
}

export function isWindows() {
    return /Win/.test(navigator.platform)
}
